export const fee_pdfs=[
    {
        "id":"1",
        "program":"Regular B.E.",
        "pdf":"https://drive.google.com/file/d/1imFUAe_GE9uW2SrzQoDLDa7dkWzOb_2K/view?usp=sharing"
    },
    {
        "id":"2",
        "program":"Lateral B.E.",
        "pdf":"https://drive.google.com/file/d/18J5Z7_2mDM6oIBhTL5-odx7tjOATvCHJ/view?usp=sharing"
    },
    {
        "id":"3",
        "program":" Regular M.E.",
        "pdf":"https://drive.google.com/file/d/1MLlimfSjLBHTIV_UPE7Rre5CkyCJ1UMZ/view?usp=sharing"
    },
    {
        "id":"4",
        "program":"Part Time B.E.",
        "pdf":"https://drive.google.com/file/d/1Zf2gNwS9hyOxBe6VF1r9_hndrutaIMDd/view?usp=drive_link"
    },
]